import { render, staticRenderFns } from "./HistoricoAlteracaoClassificacao.vue?vue&type=template&id=3809c301&scoped=true"
import script from "./HistoricoAlteracaoClassificacao.vue?vue&type=script&lang=js"
export * from "./HistoricoAlteracaoClassificacao.vue?vue&type=script&lang=js"
import style0 from "./HistoricoAlteracaoClassificacao.vue?vue&type=style&index=0&id=3809c301&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3809c301",
  null
  
)

export default component.exports